import { FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { Center, Container, Group, Select, Space } from "@mantine/core";
import { AuthSteps } from "../../entities/components/auth-steps/AuthSteps";

import { Logo } from "../../shared/svg";
import { UploadCVPage } from "../../pages/upload-cv/UploadCV";
import { QuestionnairePage } from "../../pages/questionnaire/Questionnaire";
import { EmailVerificationPage } from "../../pages/email-verification/EmailVerification";
import { SignUpPage } from "../../pages/sign-up/SignUp";
import useAuthStore from "../../store/useAuthStore";

import { useTranslation } from "react-i18next";
import { setProfileLanguage } from "../../api/profileApi";
import useProfileStore from "../../store/useProfileStore";

interface AuthProps {
  maxStep: number;
  setMaxStep: (num: number) => void;
}

export const Auth: FC<AuthProps> = ({ maxStep, setMaxStep }) => {
  const [step, setStep] = useState(0);
  const { page } = useParams();
  const { access_token } = useAuthStore();
  const navigate = useNavigate();
  const { getProfileLanguage } = useProfileStore();

  const { t, i18n } = useTranslation();

  const handleLanguageChange = async (value: string | null) => {
    if (value) {
      i18n.changeLanguage(value);
      localStorage.setItem(
        "profileLanguage",
        JSON.stringify({ [value]: value })
      );
      if (access_token) {
        await setProfileLanguage(value);
        await getProfileLanguage();
      }
    }
  };

  useEffect(() => {
    setStep(() => {
      switch (page) {
        case "sign-up":
          return 0;
        case "verify-email":
          return 0;
        case "upload-cv":
          return 1;
        case "questionnaire":
          return 2;
        default:
          return 0;
      }
    });
  }, [page]);

  const renderPage = () => {
    switch (page) {
      case "sign-up":
        return (
          <SignUpPage
            setMaxStep={setMaxStep}
            onSignUp={() => {
              setMaxStep(1);
              navigate("/auth/verify-email");
            }}
          />
        );
      case "verify-email":
        return (
          <EmailVerificationPage
            onSignUp={() => {
              setMaxStep(2);
              navigate("/auth/upload-cv");
            }}
          />
        );
      case "upload-cv":
        return (
          <UploadCVPage
            onUpload={() => {
              setMaxStep(3);
              navigate("/auth/questionnaire");
            }}
          />
        );
      case "questionnaire":
        return (
          <QuestionnairePage
            onSubmit={() => {
              setStep(4);
              navigate("/report");
              console.log(1);
            }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Group
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          padding: 20,
        }}
      >
        <Select
          value={i18n.language}
          onChange={handleLanguageChange}
          data={[
            { value: "en", label: t("english") },
            { value: "uk", label: t("ukrainian") },
          ]}
          style={{ width: 150 }}
        />
      </Group>

      <Center mt={10} mb={50}>
        <Container size="sm" w={656}>
          <center>
            <Logo />
            <Space h="34px" />
            <AuthSteps step={step} />
            <Space h="34px" />
            {renderPage()}
          </center>
        </Container>
      </Center>
    </>
  );
};
